import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";

export type PincodeServiceableResponse = {
  serviceable: boolean;
  codAvailable: boolean;
};

export type PincodeServiceableQuery = {
  pincode: string;
  carrier?: "DELHIVERY" | "EKART";
};

export const shippingApi = createApi({
  reducerPath: "shippingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/shipping",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getPincodeServiceable: build.query<PincodeServiceableResponse, PincodeServiceableQuery>({
      query: ({ pincode, carrier }) =>
        `/serviceable/${encodeURIComponent(pincode)}${
          carrier ? `?carrier=${encodeURIComponent(carrier)}` : ""
        }`,
    }),
  }),
});

export const { useGetPincodeServiceableQuery } = shippingApi;
